import { render, staticRenderFns } from "./MailingPage.vue?vue&type=template&id=394c557e&"
import script from "./MailingPage.vue?vue&type=script&lang=js&"
export * from "./MailingPage.vue?vue&type=script&lang=js&"
import style0 from "./MailingPage.vue?vue&type=style&index=0&id=394c557e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports